import React from 'react';
import {Link} from 'react-router-dom';

export default ({
  data,
  sequences,
}) => {
  return (
    <ul className="overview">
      {
        data.persons.map((person) => {
          return (
            <li
              key={person.slug}
            >
              <h3>{person.firstName} {person.familyName}</h3>
              <ul>
                {
                  person.playlist.map(slug => {
                    const sequence = sequences[slug];
                    if (sequence) {
                      return (
                        <li className="sequence-tile" key={slug}>
                          <Link to={`/sequence/${person.slug}?mode=player&sequence=${sequence.slug}`}>{sequence.titlefr}</Link>
                        </li>
                      )
                    }
                    return null;
                    
                  })
                }
              </ul>
            </li>
          )
        })
      }
    </ul>
  )
}